/**
 * ProspectVideosSection Component
 * Wrapper for VideoSection with error boundary
 */

import { ErrorBoundary } from "../../../../components/ErrorBoundary";
import { VideoSection } from "./videos/VideoSection";

interface ProspectVideosSectionProps {
  prospectId: string;
  onResetSection: () => void;
}

export function ProspectVideosSection({
  prospectId,
  onResetSection,
}: ProspectVideosSectionProps) {
  return (
    <ErrorBoundary
      fallbackTitle="Video Error"
      fallbackMessage="Failed to load videos. Please try again."
      onReset={onResetSection}
    >
      <VideoSection prospectId={prospectId} />
    </ErrorBoundary>
  );
}
